export default function createAction(type, payload) {
  return { type, payload };
}
